import RecentCharts from './RecentCharts';

export default RecentCharts;
